import React, { useRef, useState } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { useGSAP } from '@gsap/react'

gsap.registerPlugin(useGSAP, ScrollTrigger)

const TabsSection = ({tabHeaders}) => {
	const headers = tabHeaders || [];
	const listRef = useRef(null);
	const itemRefs = useRef([]);
	const indicatorRef = useRef(null);
	const [activeId, setActiveId] = useState(headers[0]?.id ?? null);

	const handleNavigation = (event, heading) => {
		event.preventDefault();
		const hash = `#${encodeURIComponent(heading.id)}`;
		if (window.location.hash !== hash) window.history.pushState(null, '', hash);
		const header = document.querySelector('.header');
		const headerOffset = header && window.getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0;
		window.scrollTo({
			top: window.scrollY + heading.getBoundingClientRect().top - headerOffset - 24,
			behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
		});
	};

	// highlight the active section's link in the nav
	useGSAP(() => {
		if (!headers.length) return;

		const moveIndicator = (index, duration = 0.4) => {
			const item = itemRefs.current[index];

			if (!item || !indicatorRef.current) return;

			gsap.to(indicatorRef.current, {
				y: item.offsetTop,
				height: item.offsetHeight,
				autoAlpha: 1,
				duration,
				ease: 'power3.out',
				overwrite: true,
			});
		};

		const handleActiveLink = (index) => {
			if (index < 0) return;

			setActiveId(headers[index].id);
			moveIndicator(index);
		};

		headers.forEach((header, index) => {
			ScrollTrigger.create({
				trigger: header,
				start: 'top 50%',
				end: 'bottom bottom',
				onEnter: () => handleActiveLink(index),
				onEnterBack: () => handleActiveLink(index),
				onLeaveBack: () => handleActiveLink(index - 1),
			});
		});

		moveIndicator(0, 0);
	}, { scope: listRef, dependencies: [headers] });

	if (!headers.length) return null;

	return (
		<ul className="tabs-nav" ref={listRef}>
			<span className="tabs-nav__indicator" ref={indicatorRef} role="presentation" aria-hidden="true" />
			{headers.map((tab, index) => {
				return <li
					key={tab.id}
					ref={(el) => (itemRefs.current[index] = el)}
					className={`tabs-nav__item${tab.id === activeId ? ' is-active' : ''}`}
				>
					<a href={`#${encodeURIComponent(tab.id)}`} onClick={(event) => handleNavigation(event, tab)} aria-current={tab.id === activeId ? 'true' : undefined}>{tab.innerText}</a>
				</li>
			})}
		</ul>
	)
}

export default TabsSection